import config from '../config';

export function debounce(callback: Function, wait:number, immediate?:boolean) {
  let timeout:any;
  return function() {
    const context = this, args = arguments;
    const later = function() {
      timeout = null;
      if (!immediate) callback.apply(context, args);
    };
    const callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) callback.apply(context, args);
  };
};

export function arrayEquals(a:any[], b:any[]) {
  if (a === b) return true;
  if (a == null || b == null) return false;
  if (a.length !== b.length) return false;
  for (var i = 0; i < a.length; ++i) {
    if (a[i] !== b[i]) return false;
  } 
  return true;
}

export function getParameterByName(name:string, url?:string) {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, '\\$&');
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

export function isDesktop() {
  return window.matchMedia(`(min-width: ${ config.breakpoint.desktop })`).matches;
}

export function openPanel(panel: HTMLElement, isActive: boolean) {
  if (isActive && panel) {
    if (panel) panel.style.maxHeight = `${ panel.scrollHeight }px`;
  } else {
    if (panel) panel.style.maxHeight = null;
  }
}

export function facebookAddToCart(cart:any) {
  if (window.fbq && cart && cart.data && cart.data.items) {
    const item = cart.data.items[0];
    window.fbq('track', 'AddToCart', {
      content_ids: [item.sku],
      content_name: item.title,
      content_type: item.product_type,
      contents: [{
        id: item.sku,
        quantity: item.quantity
      }],
      currency: window.Shopify.currency.active,
      value: (item.final_line_price / 100).toFixed(2)
    }); 
  }
}